class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
       var sectionId = this.getAttribute("data-sectionid")
      console.log(sectionId)
         document.querySelectorAll('.custom_faq_item-' + sectionId ).forEach(item => {
    const question = item.querySelector('.custom_faq_question');
    const answer = item.querySelector('.custom_faq_answer');
    const arrow = item.querySelector('.custom_arrow svg');

    question.addEventListener('click', () => {
      // Toggle answer visibility
      question.classList.toggle('active');
      answer.classList.toggle('active');

      // Toggle arrow rotation
      arrow.classList.toggle('rotated');
    });
  });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("faq-section", FaqSection);


class CustomGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);        

  var sectionId = this.getAttribute("data-section");

        Fancybox.bind(document.getElementById("custom-gallery-" + sectionId), "[data-fancybox='gallery", {    
   
});

      
      };
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-gallery", CustomGallery );